import * as React from 'react';
import {
  // Button, Col, Form, FormGroup, Label, 
  Modal,
  // Row 
} from 'reactstrap';
import { Svg } from '../Svg';

interface ICGUModalProps {
  isOpen: boolean;
  toggleUCGModal: () => void;
}

export const CGUModal: React.SFC<ICGUModalProps> = ({
  isOpen,
  toggleUCGModal,
}) => {
  return (
    <Modal size='lg' className='position-relative' isOpen={isOpen}>
      <Svg
        className='position-absolute'
        fill='primary'
        width={280}
        height={210}
        opacity={0.1}
        src='bulle-popin'
        style={{ top: '-19px', left: '-15px' }}
      />
      <div className='d-flex justify-content-end p-3'>
        <Svg
          fill='dark'
          src='close'
          width={16}
          onClick={toggleUCGModal}
        />
      </div>
  
      <div className=' pl-5 pr-5'>


<p><b><span>Informations générales</span></b></p>




<p><span>Les présentes conditions générales d’utilisation (ci-après dénommées «
Conditions Générales ») sont conclues entre :<br/>
- La société <b>BeAdvize</b>, SAS au
capital de 10.000 €, immatriculée au RCS de Paris sous le n°843 497&nbsp;637et
dont le siège social est le 76 Rue Blomet 75015 Paris (ci-après la « Société »
ou le « Site » ou « <b>BeAdvize</b> »)
d’une part<br/>
- L’utilisateur du site https//www.beadvize.fr (ci-après désigné «
l'Utilisateur ») d’autre part <br/>
Contact email : contact@beadvize.fr<br/>
Numéro de téléphone : 0664502227<br/>
Hébergeur du site : OVH<br/>
<br/>
</span>

<b><span>Préambule</span></b></p>


<p><span >La société
	exploite un site internet accessible à l’adresse https://www.beadvize.fr
	proposant une mise en relation entre : <br/>
	- des professionnels indépendants (ci-après désigné « consultants ou
	consultants freelances ») réalisant des prestations de conseil<br/>
	- des donneurs d’ordre/clients (ci-après désignés « Donneurs d’Ordre »),
	également désignés conjointement les «&nbsp;Utilisateurs Donneurs d’Ordre »</span></p>
	
	<p ><span >Ces 2 types
	d’utilisateurs sont désignés comme les « Utilisateurs ».<br/>
	Les présentes Conditions Générales ont pour objet de régir les conditions
	d’utilisation du Site ainsi que les droits et obligations des Utilisateurs.
	Tout accès ou utilisation du Site suppose l’acceptation sans réserve et le
	respect de l’ensemble des Conditions Générales. </span></p>
	
	<p  ><b><span >Inscription au Site</span></b></p>
	
	<p  ><span >Pour pouvoir
	accéder aux services proposés par le Site, l’Utilisateur doit créer un compte
	en s’inscrivant sur le Site. L’Utilisateur doit être âgé d’au moins 18 ans et
	être capable juridiquement de contracter et d’utiliser le Site conformément aux
	présentes Conditions Générales. L’Utilisateur est tenu de fournir des
	informations exactes qu’il s’engage à mettre immédiatement à jour en cas de
	modification.<br/>
	<br/>
	L'Utilisateur devra en outre communiquer à la Société tout document relatif à
	son identification ou à sa situation vis-à-vis des obligations légales en
	vigueur sur simple demande et dans un délai de 48 heures.<br/>
	<br/>
	L’accès au compte créé pour l’Utilisateur est protégé par un identifiant et un
	mot de passe. L’utilisateur est le seul responsable de tout usage qui sera fait
	de ces deux informations et il est le seul garant de leur confidentialité.
	L’Utilisateur sera tenu comme seul responsable de toute utilisation de son
	compte.<br/>
	La Société se réserve le droit de refuser toute inscription ou de mettre fin à
	toute utilisation de compte d’Utilisateur sur simplement notification
	électronique et sans obligation de motivation.</span></p>
	
	<br/>
	
	<p><b><span >Description des Services et fonctionnement du Site</span></b></p>
	
	<p  ><span >Une fois
	inscrit, l’Utilisateur peut bénéficier des Services du Site. Ces Services
	comprennent notamment :<br/>
	- Une mise en relation entre les Consultants et les Donneurs d’Ordre par
	l’intermédiaire du Site<br/>
	- Une mise à disposition d’outils pour évaluer les compétences des Consultants
	en vue d’informer les Utilisateurs Donneurs d’Ordre <br/>
	- Des prestations de conseil pour assister les Utilisateurs Donneurs d’Ordre
	dans la recherche de Consultants pouvant remplir des missions identifiées<br/>
	<br/>
	- Les Consultants ayant remplis leur fiche de renseignement et ayant été
	acceptés après évaluation de leur dossier par la Société sont inscrits dans une
	base de données anonyme. En conséquence de quoi les Utilisateurs et le Site se
	réservent le droit de modifier ces éléments à tout moment sans que cela puisse
	donner lieu à un quelconque préjudice ni à une quelconque réparation.<br/>
	<br/>
	- Les Utilisateurs Donneurs d’Ordre peuvent ensuite utiliser les outils mis à
	disposition par le Site pour identifier un ou plusieurs Consultants
	susceptibles d’effectuer une mission pour leur compte, et rentrer en relation
	avec eux. Le Site se réserve le droit de donner suite ou non à cette demande.<br/>
	<br/>
	- Sous réserve d’engagement des différents Utilisateurs de respecter les
	conditions financières et opérationnelles de la mise en relation proposées par
	la Société, le Donneur d’ordre, le consultant et la Société peuvent rentrer en
	contact en vue d’évoquer les conditions de réalisation d’une mission. En cas
	d’aboutissement des discussions, la Société signe un contrat avec le consultant
	d’une part et un contrat avec le Donneur d’Ordre d’autre part en vue de
	réaliser la mission. </span></p>
	
	<p  ><b><span >Accès au Site et aux Services</span></b></p>
	
	<p  ><span >L’accès au
	Site et aux Services est exclusivement réservé aux Utilisateurs inscrits. Les
	Utilisateurs font leur affaire personnelle de la mise en place des moyens
	permettant l’accès au Site. Ils conservent à leur charge les frais de
	télécommunication lors de l’accès et de l’utilisation du Site. Le Site est
	accessible 24heures sur 24, 7 jours sur 7 pour l’ensemble des Utilisateurs. </span></p>
	
	<p  ><span >La Société
	se réserve le droit, sans préavis ni indemnité, de fermer temporairement ou
	définitivement le Site ou l’accès à un ou plusieurs Services pour effectuer des
	mises à jour ou des modifications techniques. Elle se réserve plus généralement
	le droit d’apporter au Site et aux Services toutes les modifications et
	améliorations qu’elle jugera nécessaires ou utiles dans le cadre du bon
	fonctionnement du Site et de ses Services. </span></p>
	
	<p  ><b><span >Engagements</span></b></p>
	
	<p  ><span >L’Utilisateur
	s’engage à accéder et à utiliser le Site conformément aux lois et règlements en
	vigueur et en accord avec les dispositions des présentes Conditions
	d’Utilisation. <br/>
	L’Utilisateur s’engage notamment à :<br/>
	<br/>
	(1) Satisfaire à toutes les obligations légales et réglementaires. L’Utilisateur,
	notamment lorsqu’il est consultant, s’engage à accomplir toutes les
	déclarations et toutes les formalités nécessaires à son activité et à
	l’utilisation des Services, en matière juridique, sociale, administrative et
	fiscale notamment. Sur simple demande, l’Utilisateur s’engage à fournir tout
	document prouvant qu’il remplit toutes les obligations énoncées ci-dessus.<br/>
	<br/>
	(2) S’interdire de contourner la mise en relation proposée par le Site. L’Utilisateur
	s’interdit de publier ou de communiquer toute information permettant à un autre
	Utilisateur du Site de rentrer en contact directement avec lui sans passer par
	l’intermédiaire du Site ou de la Société. Sont en particulier visé par cette
	disposition toute communication d’adresse email ou de numéro de téléphone de
	nature à concrétiser un contact direct entre deux Utilisateurs sans passer par
	l’intermédiaire du Site ou de la Société.<br/>
	<br/>
	(3) Utiliser de manière loyale le Site. L’Utilisateur s’interdit d’utiliser le
	contenu du site pour mettre en place toute action de promotion commerciale pour
	son compte ou celui d’un tiers autre que pour les prestations de conseils
	visées par le Site. L’Utilisateur s’interdit également de constituer des bases
	de données commerciales à but de démarchage ou d’utiliser les informations
	collectées sur le site en vue d’établir des études ou en vue de mener des
	actions de recrutement non autorisées par la Société.<br/>
	<br/>
	</span></p>
	
	<p  ><b><span >Responsabilité de l’Utilisateur</span></b></p>
	
	<p  ><span >L’Utilisateur
	est seul responsable des informations et contenus qu’il diffuse par le biais du
	Site. Le Site ne contrôlant pas ces éléments avant mise en ligne. L’Utilisateur
	est seul responsable des conséquences et préjudices qui résulteraient de la
	communication d’informations ou contenus inexactes ou trompeurs. </span></p>
	
	<p  ><span >L’Utilisateur
	s’interdit également de publier tout contenu susceptibles de porter atteinte
	aux droits, à la réputation et à l’image du Site et d’une manière générale tout
	contenu qui enfreindrait les lois et règlements en vigueur. </span></p>
	
	<p  ><b><span >Responsabilité de la Société</span></b></p>
	
	<p  ><span >Le Site
	réalise ses meilleurs efforts pour assurer l’accès et le fonctionnement du Site
	24 heures sur 24, 7 jours sur 7. Toutefois, de par la nature du fonctionnement
	d’Internet, la Société ne saurait exclure l’interruption ou le mauvais
	fonctionnement du Site et des Services. Aussi la Société ne saurait être tenue
	pour responsable d’une quelconque interruption de Service, volontaire ou non,
	et des conséquences potentielles pour les Utilisateurs.<br/>
	<br/>
	Le Site ne saurait être tenue pour responsables des informations erronées,
	inexactes ou trompeuses publiées par des Utilisateurs sur le Site.<br/>
	<br/>
	Le Site sert d'intermédiaire entre L’utilisateur Donneur d’ordre et le
	consultant, et il ne saurait être tenu responsable de tout problème qui aurait
	lieu suite à cette mise en contact. Il convient aux deux parties de s'assurer
	de l'intégrité de l'autre partie avant de s'engager mutuellement sur une
	quelconque prestation. </span></p>
	
	<p><br/></p>
	
	<p  ><b><span >Données personnelles et RGPD</span></b></p>
	
	<p  ><span >Des données
	à caractère personnel de l’Utilisateur font l’objet d’un traitement informatisé
	par la Société destiné à assurer le bon fonctionnement du Site et des Services
	et également à des fins statistiques et de prospection commerciale. La Société
	est seule destinataire de ces données, les informations collectées ne sont ni
	revendue ni communiquée à des tiers.<br/>
	<br/>
	Conformément à la loi &quot;informatique et libertés&quot; du 6 janvier 1978
	modifiée, l’Utilisateur bénéficie d’un droit d’accès et de rectification aux
	informations qui le concernent. Pour exercer ce droit et obtenir communication
	des informations le concernant, l’Utilisateur peut contacter la Société par
	courrier adressé à son siège social ou par email. L’Utilisateur peut également
	s’opposer à ce traitement pour des motifs légitimes. Cette opposition peut
	toutefois entrainer une fermeture du compte de l’Utilisateur.<br/>
	<br/>
	<br/>
	</span></p>
	
	<p><b><span>Protection des données personnelles</span></b></p>
	
	<p><span >Le Règlement
	Général de Protection des données (RGPD) entre en vigueur le 25 mai 2018. Il
	définit les principes à respecter lors de la collecte, du traitement et de la
	conservation de données personnelles. Il garantit aussi les droits pour les
	personnes concernées. <br/>
	<br/>
	Le Site propose plusieurs formulaires afin de collecter les données d’un
	visiteur. </span></p>
	
	<p><b><span>Informations que nous collectons</span></b></p>
	
	<p><b><span>Informations fournies par les utilisateurs pour
	utiliser notre service</span></b></p>
	
	<p  ><span >Dans le
	cadre de votre utilisation de nos services et de votre navigation sur notre
	site internet, Le Site collecte plusieurs catégories de données dont vous
	trouverez le détail ci-dessous. Ces données proviennent : <br/>
	- Des informations que vous nous communiquez lorsque vous créez votre compte,
	que vous mettez à jour votre profil.<br/>
	- Des informations résultant de votre utilisation de nos services comme votre
	activité sur la plateforme.<br/>
	Nous ne traitons pas de catégories particulières de données (données sensibles)
	telles que les données qui révèlent l'origine raciale ou ethnique, les opinions
	politiques, les convictions religieuses ou philosophiques ou l'appartenance
	syndicale, des données génétiques, des données biométriques, des données
	concernant la santé ou des données concernant la vie sexuelle ou l'orientation
	sexuelle des personnes. </span></p>
	
	<p><b><span>Données relatives aux Consultants indépendants</span></b></p>
	
	<p  ><span >Nous
	informons au moment de la collecte du caractère obligatoire ou non de la
	donnée. </span></p>
	
	<p><b><span>Communiquées par le Consultant</span></b></p>
	
	<p  ><span >Informations
	personnelles<br/>
	- Nom<br/>
	- Prénom<br/>
	- Email<br/>
	- Numéro de téléphone<br/>
	- Localisation<br/>
	- Photo de profil<br/>
	<br/>
	Informations professionnelles<br/>
	- Expériences professionnelles<br/>
	- Compétences<br/>
	- Diplômes<br/>
	- Certifications<br/>
	- Disponibilité pour une prochaine mission<br/>
	<br/>
	</span></p>
	
	<p><b><span>Générées par votre utilisation de la plateforme</span></b></p>
	
	<p><span >Données de
	navigation - Cookies </span></p>
	
	<p><b><span>Données relatives aux Utilisateurs Donneurs d'Ordres </span></b></p>
	
	<p  ><span >Nous
	informons au moment de la collecte du caractère obligatoire ou non de la
	donnée. </span></p>
	
	<p  ><b><span>Communiquées par les Utilisateurs Donneurs d'Ordres </span></b></p>
	
	<p  ><span >Informations personnelles<br/>
	- Nom<br/>
	- Prénom<br/>
	- Adresse email<br/>
	- Numéro de Téléphone<br/>
	- Informations générales sur l’entreprise<br/>
	- Logo de l’entreprise<br/>
	- Nom de l'entreprise<br/>
	<b><br/>
	Générées par votre utilisation de la plateforme<br/>
	</b><span >Données de navigation - Cookies </span></span></p>
	
	<p  ><b><span>Informations statistiques relatives à votre
	utilisation de nos services</span></b></p>
	
	<p  ><span >Nous
	recueillons par exemple des données statistiques sur l’utilisation du moteur de
	recherche ou du formulaire de contact<br/>
	<br/>
	Les statistiques portent également sur des données commerciales telles que le
	nombre de missions réalisées, les volumes d’affaires par catégorie de
	consultants, clients. </span></p>
	
	<p  ><b><span>Finalités</span></b></p>
	
	<p  ><span >Les données
	que nous collectons nous permettent de fournir, gérer, protéger et améliorer
	nos services, d'en développer de nouveaux, et de protéger aussi bien nos
	utilisateurs que nous-mêmes. </span></p>
	
	<p  ><span >En
	particulier, ces données sont destinées à<br/>
	<br/>
	- La création et la gestion de votre compte ;<br/>
	- L’utilisation des services du site ;<br/>
	- Pour les clients, la possibilité de pouvoir vous contacter pour vous proposer
	des profils en adéquation avec vos recherches ;<br/>
	- S’assurer que les missions proposées soient pertinentes ;<br/>
	- Garantir la qualité des profils, vérifier les informations des profils ; </span></p>
	
	<p  ><b><span >Destinataires des données</span></b></p>
	
	<p  ><span >Le Site est
	destinataire des données à caractère personnel recueillies par l'intermédiaire
	du site. <br/>
	<br/>
	</span></p>
	
	<p  ><b><span >Sécurité des
	données</span></b></p>
	
	<p  ><span >Nous mettons
	en œuvre les mesures les mesures techniques et organisationnelles appropriées
	afin de garantir la sécurité, la confidentialité, l'intégrité, la disponibilité
	et la résilience constantes des systèmes et des services de traitement/ de
	notre système d’information et de vos données et protéger les données contre
	destruction, la perte, l'altération, la divulgation non autorisée de données à
	caractère personnel transmises, conservées ou traitées d'une autre manière, ou
	l'accès non autorisé à de telles données. </span></p>
	
	<p  ><span >Nous nous
	engageons à mettre en œuvre tous les moyens disponibles pour assurer la
	sécurité et la confidentialité de ces données, en particulier :<br/>
	<br/>
	- L’accès aux données personnelles est strictement réservé aux salariés du Site
	qui ont besoin d’y accéder afin de les traiter en notre nom. Ces personnes sont
	soumises à de strictes obligations de confidentialité et sont susceptibles de
	faire l’objet de sanctions disciplinaires pouvant aller jusqu’au licenciement
	en cas de manquement à ces obligations.<br/>
	<br/>
	</span></p>
	
	<p ><b><span >Les droits</span></b></p>
	
	<p  ><span >- Gestion de
	vos informations<br/>
	<br/>
	Vous pouvez accéder et mettre à jour certaines de vos informations par le biais
	des paramètres de votre compte BeAdvize<br/>
	<br/>
	- Rectification d’informations inexactes ou incomplètes.<br/>
	<br/>
	Vous avez le droit de nous demander de corriger des informations personnelles
	inexactes ou incomplètes vous concernant.<br/>
	<br/>
	- Conservation des données<br/>
	Après clôture d'un compte, les données sont définitivement supprimées à
	l’exception de celles pouvant permettre au Site de justifier de l’exécution de
	ses obligations légales ou contractuelles. Les données ainsi conservées le sont
	pendant une période limitée<br/>
	</span></p>
	
	<p  ><b><span >Cookies</span></b></p>
	
	<p  ><span >Lors de la
	consultation du Site, des cookies sont susceptibles d’être déposés sur le
	disque dur du terminal de l’Utilisateur (ordinateur, tablette, mobile, etc.).
	Un cookie est un fichier texte, qui a notamment pour but de collecter des
	informations relatives à la navigation et à l’identification de l’Utilisateur. </span></p>
	
	<p  ><span >La durée
	maximale de conservation des cookies implantés par la Société est de 12 mois.
	L’Utilisateur dispose toutefois de la possibilité de s’opposer à l’utilisation
	de ces cookies en configurant de manière appropriée son logiciel de navigation.
	</span></p>
	
	<p  ><b><span >Propriété intellectuelle du Site</span></b></p>
	
	<p  ><span >Le Site et
	chacun des éléments qui le composent constituent, ensemble, une œuvre protégée
	par les lois en vigueur sur la propriété intellectuelle, dont BeAdvize est
	titulaire. Aucune exploitation commerciale, reproduction, représentation,
	utilisation, adaptation, modification, incorporation, traduction,
	commercialisation, partielle ou intégrale de ces éléments ne pourra en être
	faite sans l'accord préalable et écrit du Site. </span></p>
	
	<p  ><b><span >Propriété intellectuelle des contenus publiés</span></b></p>
	
	<p  ><span >Tout
	Utilisateur qui publie des éléments de contenu (texte, images, commentaires …)
	sur le Site garde l’entière propriété de tout ce qu’il publie. </span></p>
	
	<p  ><span >En
	communiquant des contenus par le biais du Site, l’Utilisateur autorise
	expressément Le Site à utiliser, diffuser, héberger, stocker, reproduire,
	communiquer, publier, modifier, adapter, traduire et afficher tout ou partie du
	Contenu sur le Site, les réseaux sociaux ou sur tous autres supports, par tous
	moyens, à des fins d’exploitation, d’amélioration, de promotion, de marketing,
	de publicité des Services et du Site ou pour les besoins de la mise en place de
	partenariats. Cette autorisation est valable pour le monde entier et pour toute
	la durée de l’inscription de l’Utilisateur. </span></p>
	
	<p  ><span >L’Utilisateur
	reconnaît que toute utilisation de son contenu effectuée par BeAdvize
	préalablement à sa désinscription, la suppression ou la résiliation de son
	compte ne pourra pas être remise en cause. </span></p>
	
	<p  ><b><span >Durée, résiliation et sanctions</span></b></p>
	
	<p  ><span >Le présent
	contrat est conclu pour une durée indéterminée à compter de l’acceptation des
	Conditions Générales par l’Utilisateur. </span></p>
	
	<p  ><span >Dans le cas
	où l’Utilisateur ne respecterait pas tout ou partie des Conditions Générales ou
	plus largement les lois et règlements en vigueur, la Société se réserve le
	droit de suspendre ou fermer le compte de l’Utilisateur immédiatement, sans
	préjudice de tous les dommages et intérêts éventuels que la Société pourrait
	réclamer. </span></p>
	
	<p  ><br/></p>
	
	<p  ><b><span >Modification des conditions générales</span></b></p>
	
	<p  ><span >La Société
	se réserve le droit de modifier tout ou partie des présentes Conditions
	Générales. En cas de modification, la Société informera les Utilisateurs par
	tout moyen à sa disposition. </span></p>
	
	<p  ><span >L’Utilisateur
	disposera d’un délai de 48h à compter de la date de notification pour faire
	part de son éventuel désaccord quant aux nouvelles dispositions des Conditions
	Générales par tout moyen. A défaut de notification du désaccord dans les délais
	précisés ci-dessus, l’Utilisateur sera réputé avoir accepté les modifications
	apportées aux Conditions Générales. </span></p>


	
	<p><b><span >Droit applicable et juridiction compétence</span></b></p>
	
	<p  ><span >Les
	présentes Conditions Générales sont soumises au droit français. Tout litige
	relatif à ces Conditions Générales relève de la compétence exclusive des
	juridictions du ressort de la Cour d’appel de Paris. </span></p>
	
	


      </div>
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/shared/Modals/CGUModal.tsx